import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=0b4496c7&scoped=true"
import script from "./LocaleSelector.vue?vue&type=script&lang=js"
export * from "./LocaleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4496c7",
  null
  
)

export default component.exports